var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloudNotSaved = function SvgCloudNotSaved(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M14.467 10.745a3 3 0 0 0-2.52-4.066 4 4 0 0 0-4.814-3.251m-2.275 1.43a4 4 0 0 0-.805 1.822 3 3 0 0 0 .28 5.987h7.334a3 3 0 0 0 .874-.13M2 2l12 12"
  })));
};
export default SvgCloudNotSaved;